
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, Calendar, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import PropertyFeature from "@/components/PropertyFeature";

const FeaturesSection = () => {
  return (
    <section className="py-16 md:py-24 px-6 bg-cottage-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.span 
            className="inline-block text-cottage-600 font-medium text-sm px-3 py-1 bg-white rounded-full mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Property Highlights
          </motion.span>
          <motion.h2 
            className="text-3xl md:text-4xl font-bold text-cottage-800 mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            What Makes The Cottage Special
          </motion.h2>
          <motion.p 
            className="text-cottage-600"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Discover what makes this Flowerpot family holiday house the perfect rural Tasmania accommodation for your getaway.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <PropertyFeature 
            icon={<Star size={24} />} 
            title="Stunning Location" 
            description="A peaceful retreat in Tasmania nestled in Flowerpot, with breathtaking views of the D'Entrecasteaux Channel and Bruny Island." 
          />
          <PropertyFeature 
            icon={<Calendar size={24} />} 
            title="Available Year-Round" 
            description="This 4 bedroom accommodation in Tasmania is available year-round, perfect for multi-generational family holidays in every season." 
          />
          <PropertyFeature 
            icon={<MapPin size={24} />} 
            title="Strategic Location" 
            description="Ideal for mainland Australia to Tasmania travellers — a perfect base for exploring Bruny Island, Cygnet, Geeveston and the Huon Valley." 
          />
          <PropertyFeature 
            icon={<Star size={24} />} 
            title="Comfortable Interiors" 
            description="Thoughtfully designed spaces with comfortable furnishings, creating a cozy and welcoming atmosphere." 
          />
          <PropertyFeature 
            icon={<Star size={24} />} 
            title="Modern Amenities" 
            description="Enjoy all the comforts of home, including a fully equipped kitchen, luxurious bathroom, and high-speed internet." 
          />
          <PropertyFeature 
            icon={<Star size={24} />} 
            title="Private Outdoor Space" 
            description="Relax in your own private garden area, perfect for morning coffee or evening gatherings under the stars." 
          />
        </div>

        <div className="mt-12 text-center">
          <Link to="/details">
            <Button className="bg-cottage-600 hover:bg-cottage-700 text-white">
              View All Features
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
